import { IBaseProfileFiltersConfig, IBaseFiltersCollectedData } from './types';

export const collectBaseFiltersData = ({ ...config }: IBaseProfileFiltersConfig): IBaseFiltersCollectedData => {
  const {
    isConsumerOverview,
    skipNextUpdate,
    changedProducts,
    profileType,
    query,
  } = config;
  let { sector, industry } = query;
  const {
    validProducts,
    validRegions,
  } = changedProducts;

  return {
    validProducts,
    validRegions,
    industry,
    sector,
    isConsumerOverview,
    skipNextUpdate,
    profileType,
  };
};
